export default "__VITE_ASSET__ca3ff551__"